"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "registers",
    path: "/registers",
    component: "RegisterView"
});
(0, core_1.addRoute)({
    name: "letterRegister",
    path: "/letter-register",
    component: "RegisterView"
});
(0, core_1.addRoute)({
    name: "invoiceRegister",
    path: "/invoice-register",
    component: "RegisterView"
});
let RegisterView = class RegisterView extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_states = new core_1.ComponentValueCache(this, "states", "RegisterView.states");
    }
    getQueryParameters(...args) {
        return {
            sort_mode: 'desc',
            register_id: this.selectedRegisterId,
            version_id: this.selectedVersionId
        };
    }
    invoiceTypeBadgeClass(...args) {
        const [row] = args;
        const cc = this.$config.invoice.types.colorCodes[row.invoice_type];
        return `bg-${cc.bg} text-${cc.text}`;
    }
    priorityBadgeClass(...args) {
        const [row] = args;
        const priority = row.priority;
        if (priority == 1) {
            return `border border-purple-500 text-purple-500`;
        }
        if (priority == 2) {
            return `border border-red-500 text-red-500`;
        }
    }
    invoiceFormatter(...args) {
        const [grid] = args;
        if (!this._invoiceFormatter) {
            this._invoiceFormatter = grid.ALL_FORMATTERS.chain({
                formatters: [
                    {
                        name: 'template',
                        format: '{{ document.invoice_number }}'
                    },
                    {
                        name: 'link',
                        href: '#',
                        className: 'command-link'
                    },
                    {
                        name: 'cellclass',
                        value: row => ({
                            'font-weight-bold': true,
                            'bg-yellow-500 text-yellow-800': row.is_corrected,
                            'bg-red-300 text-red-800': row.is_reversed,
                        })
                    }
                ]
            });
        }
        return this._invoiceFormatter;
    }
    referenceNumberFormatter(...args) {
        const [grid] = args;
        if (!this._referenceNumberFormatter) {
            this._referenceNumberFormatter = grid.ALL_FORMATTERS.getvalue({
                field: 'reference_number',
                source: 'row'
            });
        }
        return this._referenceNumberFormatter;
    }
    documentFormatter(...args) {
        const [row, cell, value, columnDef, data, grid] = args;
        if (value && value.invoice_number) {
            return this.invoiceFormatter(grid)(...args);
        }
        if (data.reference_number) {
            return this.referenceNumberFormatter(grid)(row, cell, data.reference_number, columnDef, data, grid);
        }
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    states;
    selectedItems;
    statuses;
    async $$load_statuses() {
        return this.$fn.fetch('get_tags', { parameters: { tag_type: 'register-entry:status' } }).then(data => _.map(data, p => p.name));
    }
    selectedStatus;
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('list_register_entries', { parameters: this.getQueryParameters });
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2248226175642056_columnDefaults;
    b_2248226175642056_columns;
    async $$load_b_2248226175642056_columns() {
        return [{
                field: "entry_number",
                name: this.$fn.pgettext("Register", "No."),
                type: "command",
                formatter: [{
                        name: "chain",
                        formatters: [{
                                name: "link",
                                href: "#",
                            },
                            {
                                name: "cellclass",
                                value: (row) => ({
                                    'font-weight-bold': true,
                                    'bg-yellow-200': !row.locked,
                                    'bg-gray-dark-100': row.locked,
                                    'text-decoration-line-through': row.void,
                                }),
                            },
                        ],
                    },
                ],
            },
            {
                field: "entry_date",
                name: this.$fn.pgettext("Register", "Date"),
                type: "date",
            },
            {
                field: "direction",
                name: this.$fn.pgettext("Register", "Direction"),
                formatter: {
                    name: "chain",
                    formatters: [{
                            name: "gettext",
                            context: "RegisterEntryDirection",
                            conversion: "StartCase",
                            filterInput: true,
                        },
                    ],
                },
            },
            {
                field: "document_type",
                name: this.$fn.pgettext("Register", "Document type"),
                formatter: {
                    name: "chain",
                    formatters: [{
                            name: "gettext",
                            context: "RegisterDocumentType",
                            conversion: "StartCase",
                            filterInput: true,
                        },
                    ],
                },
            },
            {
                field: "attachments",
                name: this.$fn.pgettext("Register", "Attachments"),
                type: "command",
                formatter: {
                    name: "attachment",
                },
            },
            {
                field: "delivery_modes",
                name: this.$fn.pgettext("Register", "Delivery mode"),
                formatter: {
                    name: "join",
                    separator: ", ",
                },
            },
            {
                field: "clerk",
                name: this.$fn.pgettext("Register", "Clerk"),
            },
            {
                field: "project",
                name: this.$fn.pgettext("Register", "Project"),
                formatter: {
                    name: "chain",
                    mode: "mapReduce",
                    formatterContext: "item",
                    formatters: [{
                            name: "getvalue",
                            opts: {
                                field: "code,name",
                                source: "value",
                                separator: " • ",
                            },
                        },
                        {
                            name: "routeLink",
                            to: "project",
                            navigateOnIconClick: true,
                            params: {
                                id: "id",
                            },
                        },
                    ],
                },
            },
            {
                field: "priority",
                name: this.$fn.pgettext("Register", "Priority"),
                formatter: {
                    name: "chain",
                    formatters: [{
                            name: "mapvalue",
                            mapping: {
                                0: this.$fn.pgettext("Priority", "normal"),
                                1: this.$fn.pgettext("Priority", "important"),
                                2: this.$fn.pgettext("Priority", "urgent"),
                            },
                        },
                        {
                            name: "badge",
                            pill: true,
                            badgeClass: this.priorityBadgeClass,
                        },
                    ],
                },
            },
            {
                field: "document",
                name: this.$fn.pgettext("Register", "Document"),
                type: "command",
                formatter: this.documentFormatter,
            },
            {
                field: "partner",
                name: this.$fn.pgettext("Register", "Partner"),
                formatter: {
                    name: "chain",
                    mode: "mapReduce",
                    formatterContext: "item",
                    formatters: [{
                            name: "getvalue",
                            opts: {
                                field: "name",
                                source: "value",
                            },
                        },
                        {
                            name: "routeLink",
                            to: "company",
                            navigateOnIconClick: true,
                            params: {
                                id: "id",
                            },
                        },
                    ],
                },
            },
            {
                field: "subject",
                name: this.$fn.pgettext("Register", "Subject"),
            },
            {
                field: "ref_entry_number",
                name: this.$fn.pgettext("Register", "Ref."),
                type: "command",
                formatter: [{
                        name: "chain",
                        formatters: [{
                                name: "link",
                                href: "#",
                            },
                        ],
                    },
                ],
            },
            {
                field: "status",
                name: this.$fn.pgettext("Register", "Status"),
            },
            {
                field: "categories",
                name: this.$fn.pgettext("Register", "Category"),
            },
            {
                field: "delivery_date",
                name: this.$fn.pgettext("Register", "Delivery date"),
                type: "date",
            },
            {
                field: "notes",
                name: this.$fn.pgettext("Register", "Notes"),
            },
            {
                field: "created_at",
                name: this.$fn.pgettext("BrowserColumn", "Create time"),
                formatter: "datetime",
            },
        ];
    }
    dataMembers = ['states', 'selectedItems', 'statuses', 'selectedStatus', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                states: {
                    selectedRegisterId: null,
                    selectedVersionId: null,
                },
                selectedItems: [],
                statuses: null,
                selectedStatus: null,
                ds: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2248226175642056_columnDefaults: {
                    filterable: true,
                    resizable: true,
                    selectable: true,
                },
                b_2248226175642056_columns: null,
            },
        };
    }
    get selectedRegisterId() {
        if (this.loaded) {
            return this.states.selectedRegisterId;
        }
        return null;
    }
    get selectedVersionId() {
        if (this.loaded) {
            return this.states.selectedVersionId;
        }
        return null;
    }
    get isRegisterSelected() {
        if (this.loaded) {
            return this.selectedRegisterId && this.selectedVersionId;
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("Register", "Registers"),
                icon: this.$config.register.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_4332_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_reloadSlickgrid_4336_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async act_2248226175642056_reloadSlickgrid_4338_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async evh_2248226175642056_close_4337_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_2248226175642056_showModal_4334_getActionArgs($event) {
        return {
            name: "RegisterEntry",
            props: {
                oid: $event.data.data.id,
            },
        };
    }
    async evh_2248226175642056_command_4333_getWhen($event) {
        return $event.data.column.id === 'entry_number';
    }
    async act_2248226175642056_reloadSlickgrid_4342_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async act_2248226175642056_reloadSlickgrid_4344_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async evh_2248226175642056_close_4343_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_2248226175642056_showModal_4340_getActionArgs($event) {
        return {
            name: "RegisterEntry",
            props: {
                oid: $event.data.data.ref_entry_id,
            },
        };
    }
    async evh_2248226175642056_command_4339_getWhen($event) {
        return $event.data.column.id === 'ref_entry_number';
    }
    async act_2248226175642056_script_4346_getActionArgs_value($event) {
        this.$app.attachments.downloadAttachmentFromSlickCommand($event);
    }
    async act_2248226175642056_script_4346_getActionArgs($event) {
        return {
            value: () => this.act_2248226175642056_script_4346_getActionArgs_value($event),
        };
    }
    async evh_2248226175642056_command_4345_getWhen($event) {
        return $event.data.column.id === 'attachments';
    }
    async act_2248226175642056_showModal_4348_getActionArgs($event) {
        return {
            name: "Invoice",
            props: {
                oid: $event.data.data.document.id,
            },
        };
    }
    async evh_2248226175642056_command_4347_getWhen($event) {
        return $event.data.column.id === 'document' &&
            !!$event.data.data.document &&
            !!$event.data.data.document.invoice_number;
    }
    async evh_2248226175642056_command(event, scope) {
        return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_4350_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_6466705138206980_reloadSlickgrid_4352_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async evh_6466705138206980_input(event, scope) {
        return await this.actions.evh_6466705138206980_input.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_reloadSlickgrid_4356_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async act_8320016629450276_reloadSlickgrid_4358_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async evh_8320016629450276_close_4357_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_8320016629450276_showModal_4354_getActionArgs($event) {
        return {
            name: "RegisterEntry",
            props: {
                registerId: this.states.selectedRegisterId,
                versionId: this.states.selectedVersionId,
            },
        };
    }
    async evh_8320016629450276_click(event, scope) {
        return await this.actions.evh_8320016629450276_click.executeFromDOM(this, event, scope);
    }
    async act_5382094220310827_setData_4360_getActionArgs($event) {
        return {
            path: "selectedStatus",
            value: $event.scope.status,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_5382094220310827_reloadSlickgrid_4364_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async act_5382094220310827_request_4362_getActionArgs($event) {
        return {
            operation: "bulk_update_register_entry",
            data: _.map(this.selectedItems, p => ({ id: p.id, status: this.selectedStatus })),
        };
    }
    async evh_5382094220310827_clickPreventStop(event, scope) {
        return await this.actions.evh_5382094220310827_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_8704926098283402_setData_4366_getActionArgs($event) {
        return {
            path: "selectedStatus",
            value: null,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_8704926098283402_reloadSlickgrid_4370_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async act_8704926098283402_request_4368_getActionArgs($event) {
        return {
            operation: "bulk_update_register_entry",
            data: _.map(this.selectedItems, p => ({ id: p.id, status: this.selectedStatus })),
        };
    }
    async evh_8704926098283402_clickPreventStop(event, scope) {
        return await this.actions.evh_8704926098283402_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4332 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4332_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4331 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4332,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4331],
        });
        const act_2248226175642056_reloadSlickgrid_4336 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_2248226175642056_reloadSlickgrid_4336_getActionArgs,
            displayName: "reloadSlickgrid",
            events: [],
        });
        const evh_2248226175642056_saved_4335 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_reloadSlickgrid_4336,
            event: "saved",
            displayName: "reloadSlickgrid",
        });
        const act_2248226175642056_reloadSlickgrid_4338 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_2248226175642056_reloadSlickgrid_4338_getActionArgs,
            displayName: "reloadSlickgrid",
            events: [],
        });
        const evh_2248226175642056_close_4337 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_reloadSlickgrid_4338,
            event: "close",
            when: this.evh_2248226175642056_close_4337_getWhen,
            displayName: "reloadSlickgrid",
        });
        const act_2248226175642056_showModal_4334 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_4334_getActionArgs,
            displayName: "showRegisterEntryModal",
            events: [evh_2248226175642056_saved_4335, evh_2248226175642056_close_4337],
        });
        const evh_2248226175642056_command_4333 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_4334,
            event: "command",
            when: this.evh_2248226175642056_command_4333_getWhen,
            displayName: "showRegisterEntryModal",
        });
        const act_2248226175642056_reloadSlickgrid_4342 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_2248226175642056_reloadSlickgrid_4342_getActionArgs,
            displayName: "reloadSlickgrid",
            events: [],
        });
        const evh_2248226175642056_saved_4341 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_reloadSlickgrid_4342,
            event: "saved",
            displayName: "reloadSlickgrid",
        });
        const act_2248226175642056_reloadSlickgrid_4344 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_2248226175642056_reloadSlickgrid_4344_getActionArgs,
            displayName: "reloadSlickgrid",
            events: [],
        });
        const evh_2248226175642056_close_4343 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_reloadSlickgrid_4344,
            event: "close",
            when: this.evh_2248226175642056_close_4343_getWhen,
            displayName: "reloadSlickgrid",
        });
        const act_2248226175642056_showModal_4340 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_4340_getActionArgs,
            displayName: "showRefEntryModal",
            events: [evh_2248226175642056_saved_4341, evh_2248226175642056_close_4343],
        });
        const evh_2248226175642056_command_4339 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_4340,
            event: "command",
            when: this.evh_2248226175642056_command_4339_getWhen,
            displayName: "showRefEntryModal",
        });
        const act_2248226175642056_script_4346 = new core_1.actions.ScriptAction({
            actionArgs: this.act_2248226175642056_script_4346_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_command_4345 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_script_4346,
            event: "command",
            when: this.evh_2248226175642056_command_4345_getWhen,
            displayName: "script",
        });
        const act_2248226175642056_showModal_4348 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_4348_getActionArgs,
            displayName: "showInvoiceModal",
            events: [],
        });
        const evh_2248226175642056_command_4347 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_4348,
            event: "command",
            when: this.evh_2248226175642056_command_4347_getWhen,
            displayName: "showInvoiceModal",
        });
        const evh_2248226175642056_command = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_command_4333, evh_2248226175642056_command_4339, evh_2248226175642056_command_4345, evh_2248226175642056_command_4347],
        });
        const act_2248226175642056_setData_4350 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_4350_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_selectedRowsChanged_4349 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_4350,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_2248226175642056_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_selectedRowsChanged_4349],
        });
        const act_6466705138206980_reloadSlickgrid_4352 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_6466705138206980_reloadSlickgrid_4352_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_input_4351 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_reloadSlickgrid_4352,
            event: "input",
            displayName: "reloadSlickgrid",
        });
        const evh_6466705138206980_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6466705138206980_input_4351],
        });
        const act_8320016629450276_reloadSlickgrid_4356 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_8320016629450276_reloadSlickgrid_4356_getActionArgs,
            displayName: "reloadSlickgrid",
            events: [],
        });
        const evh_8320016629450276_saved_4355 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_reloadSlickgrid_4356,
            event: "saved",
            displayName: "reloadSlickgrid",
        });
        const act_8320016629450276_reloadSlickgrid_4358 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_8320016629450276_reloadSlickgrid_4358_getActionArgs,
            displayName: "reloadSlickgrid",
            events: [],
        });
        const evh_8320016629450276_close_4357 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_reloadSlickgrid_4358,
            event: "close",
            when: this.evh_8320016629450276_close_4357_getWhen,
            displayName: "reloadSlickgrid",
        });
        const act_8320016629450276_showModal_4354 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_4354_getActionArgs,
            events: [evh_8320016629450276_saved_4355, evh_8320016629450276_close_4357],
        });
        const evh_8320016629450276_click_4353 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_4354,
            event: "click",
            displayName: "showModal",
        });
        const evh_8320016629450276_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_click_4353],
        });
        const act_5382094220310827_setData_4360 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5382094220310827_setData_4360_getActionArgs,
            events: [],
        });
        const evh_5382094220310827_clickPreventStop_4359 = new core_1.actions.EventHandlerImpl({
            action: act_5382094220310827_setData_4360,
            event: "click.prevent.stop",
            displayName: "setData",
        });
        const act_5382094220310827_reloadSlickgrid_4364 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_5382094220310827_reloadSlickgrid_4364_getActionArgs,
            displayName: "reloadSlickgrid",
            events: [],
        });
        const evh_5382094220310827_success_4363 = new core_1.actions.EventHandlerImpl({
            action: act_5382094220310827_reloadSlickgrid_4364,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_5382094220310827_request_4362 = new core_1.actions.RequestAction({
            actionArgs: this.act_5382094220310827_request_4362_getActionArgs,
            displayName: "setStatus",
            events: [evh_5382094220310827_success_4363],
        });
        const evh_5382094220310827_clickPreventStop_4361 = new core_1.actions.EventHandlerImpl({
            action: act_5382094220310827_request_4362,
            event: "click.prevent.stop",
            displayName: "setStatus",
        });
        const evh_5382094220310827_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5382094220310827_clickPreventStop_4359, evh_5382094220310827_clickPreventStop_4361],
        });
        const act_8704926098283402_setData_4366 = new core_1.actions.SetDataAction({
            actionArgs: this.act_8704926098283402_setData_4366_getActionArgs,
            events: [],
        });
        const evh_8704926098283402_clickPreventStop_4365 = new core_1.actions.EventHandlerImpl({
            action: act_8704926098283402_setData_4366,
            event: "click.prevent.stop",
            displayName: "setData",
        });
        const act_8704926098283402_reloadSlickgrid_4370 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_8704926098283402_reloadSlickgrid_4370_getActionArgs,
            displayName: "reloadSlickgrid",
            events: [],
        });
        const evh_8704926098283402_success_4369 = new core_1.actions.EventHandlerImpl({
            action: act_8704926098283402_reloadSlickgrid_4370,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_8704926098283402_request_4368 = new core_1.actions.RequestAction({
            actionArgs: this.act_8704926098283402_request_4368_getActionArgs,
            displayName: "setStatus",
            events: [evh_8704926098283402_success_4369],
        });
        const evh_8704926098283402_clickPreventStop_4367 = new core_1.actions.EventHandlerImpl({
            action: act_8704926098283402_request_4368,
            event: "click.prevent.stop",
            displayName: "setStatus",
        });
        const evh_8704926098283402_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8704926098283402_clickPreventStop_4365, evh_8704926098283402_clickPreventStop_4367],
        });
        return {
            act_7315092382398562_closeModal_4332,
            evh_7315092382398562_close_4331,
            evh_7315092382398562_close,
            act_2248226175642056_reloadSlickgrid_4336,
            evh_2248226175642056_saved_4335,
            act_2248226175642056_reloadSlickgrid_4338,
            evh_2248226175642056_close_4337,
            act_2248226175642056_showModal_4334,
            evh_2248226175642056_command_4333,
            act_2248226175642056_reloadSlickgrid_4342,
            evh_2248226175642056_saved_4341,
            act_2248226175642056_reloadSlickgrid_4344,
            evh_2248226175642056_close_4343,
            act_2248226175642056_showModal_4340,
            evh_2248226175642056_command_4339,
            act_2248226175642056_script_4346,
            evh_2248226175642056_command_4345,
            act_2248226175642056_showModal_4348,
            evh_2248226175642056_command_4347,
            evh_2248226175642056_command,
            act_2248226175642056_setData_4350,
            evh_2248226175642056_selectedRowsChanged_4349,
            evh_2248226175642056_selectedRowsChanged,
            act_6466705138206980_reloadSlickgrid_4352,
            evh_6466705138206980_input_4351,
            evh_6466705138206980_input,
            act_8320016629450276_reloadSlickgrid_4356,
            evh_8320016629450276_saved_4355,
            act_8320016629450276_reloadSlickgrid_4358,
            evh_8320016629450276_close_4357,
            act_8320016629450276_showModal_4354,
            evh_8320016629450276_click_4353,
            evh_8320016629450276_click,
            act_5382094220310827_setData_4360,
            evh_5382094220310827_clickPreventStop_4359,
            act_5382094220310827_reloadSlickgrid_4364,
            evh_5382094220310827_success_4363,
            act_5382094220310827_request_4362,
            evh_5382094220310827_clickPreventStop_4361,
            evh_5382094220310827_clickPreventStop,
            act_8704926098283402_setData_4366,
            evh_8704926098283402_clickPreventStop_4365,
            act_8704926098283402_reloadSlickgrid_4370,
            evh_8704926098283402_success_4369,
            act_8704926098283402_request_4368,
            evh_8704926098283402_clickPreventStop_4367,
            evh_8704926098283402_clickPreventStop,
            reloadSlickgrid: act_8704926098283402_reloadSlickgrid_4370,
            showRegisterEntryModal: act_2248226175642056_showModal_4334,
            showRefEntryModal: act_2248226175642056_showModal_4340,
            showInvoiceModal: act_2248226175642056_showModal_4348,
            setStatus: act_8704926098283402_request_4368,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], RegisterView.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RegisterView.prototype, "onSize", null);
RegisterView = __decorate([
    (0, vue_property_decorator_1.Component)()
], RegisterView);
exports.default = RegisterView;
vue_property_decorator_1.Vue.component("RegisterView", RegisterView);
